<template lang="pug">
.mobile-frame(style="width: 500px")
  .mobile-header.border-bottom
    pr-subtitle {{ $t("Mobile Application") }}
  .mobile-status.surface-bg-darker.px-5.py-3.d-flex.align-items-center
    .info.flex-grow-1.d-flex.align-items-center
      i.fal.fa-wifi.text-warning.mr-3
      span {{ $t("Please make sure you are connected to the guest network before scanning the QR code.") }}
  .mobile-body.d-flex.align-items-center.flex-column.justify-content-center
    .qr-code(v-nv)
      .information.d-flex.border.py-3.px-3.justify-content-center
        span {{ $t("Connect to Wi-Fi") }}
        i.fal.fa-wifi.mx-3.text-success
        span.text-success.font-weight-bold {{ ssid }}
      img.qrcode(:src="qrcode", v-if="qrcode")
      .qr-header.surface-bg-darker.px-4.py-3.text-center {{ $t("Scan the QR code to use mobile application") }}
</template>

<script>
export default {
  name: "mobile",
  data() {
    return {
      qrcode: null
    }
  },
  computed: {
    ssid() {
      return __.device.config("CAST_SSID")
    }
  },
  async created() {
    this.qrcode = await __.api.get.rcGetQr()
  },
  async mounted() {
    this.$emit("ready")
    this.$emit("background", "/v2/assets/images/mobile_bg.jpg")
    _$.nav.sync("sideload", true)
  }
}
</script>

<style lang="scss">
.mobile-frame {
  height: 100%;
  display: flex;
  flex-direction: column;

  .mobile-header {
    padding: 1.5rem 3rem;
    text-align: center;
  }
  .mobile-body {
    padding: 0 3rem;
    flex: 1 0 auto;

    .qr-code {
      border-radius: 10px;
      overflow: hidden;
      width: 300px;

      img.qrcode {
        width: 100%;
      }
    }
  }
}
</style>
